import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useSEO } from "../lib/seo";
import { MapPin, Briefcase } from "@phosphor-icons/react";

export default function JobsList() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  useSEO({
    title: "Browse Jobs — Skilled Trades, Temp Work & Freelance Gigs",
    description: "Find open jobs across Canada — from local skilled trades to remote freelance projects. Apply and get hired on CanHireSolution.com.",
    path: "/jobs",
  });
  useEffect(() => {
    api.get("/jobs").then((r) => setJobs(r.data)).finally(() => setLoading(false));
  }, []);
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-24 pb-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-2">Open Jobs</div>
        <h1 className="font-display text-4xl mb-8">Browse Jobs</h1>
        {loading ? (
          <div className="text-slate-500">Loading…</div>
        ) : jobs.length === 0 ? (
          <div className="border border-dashed border-slate-300 p-12 text-center">
            <Briefcase size={32} className="mx-auto text-slate-400 mb-2" />
            <p className="text-sm text-slate-600">No open jobs right now.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {jobs.map((j) => (
              <Link key={j.job_id} to={`/jobs/${j.job_id}`} className="border border-slate-200 p-6 bg-white hover:-translate-y-1 hover:shadow-md transition-all" data-testid={`browse-job-${j.job_id}`}>
                <div className="text-xs uppercase tracking-wider text-slate-500 mb-1">{j.category}</div>
                <div className="font-display text-xl mb-2">{j.title}</div>
                <p className="text-sm text-slate-700 line-clamp-3 mb-3">{j.description}</p>
                <div className="flex items-center justify-between text-sm">
                  <span className="flex items-center gap-1 text-slate-600"><MapPin size={14} /> {j.city}, {j.province}</span>
                  <span className="font-semibold">${j.budget_min}–${j.budget_max}</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
